// 账号注销 - 文案与校验配置

// 校验正则
export const reg = {
  phone: /^1([358][0-9]|4[01456879]|6[2567]|7[0135678]|9[012356789])[0-9]{8}$/,
  code: /^[0-9]{6}$/,
  // 18 位身份证（含末位 X）
  idCard: /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/,
};

// 注销原因下拉选项（value 对应接口 reasonType 枚举）
export const REASONS = [
  { text: "不再使用该账号", value: "no_need" },
  { text: "体验不佳", value: "bad_experience" },
  { text: "隐私或安全原因", value: "privacy" },
  { text: "其他", value: "other" },
];

// 选择「其他」时需填写原因（对应 reasonType=other）
export const OTHER_REASON = "other";

// 注销须知条款
export const NOTICE = {
  lead:
    "为防止误操作，请您再次确认是否注销账号，并仔细阅读注销后果，您自愿承担其所（可能）产生的所有后果：",
  items: [
    "您将无法登录、使用该游戏账号。我们将无法为您恢复该账号的注册信息。",
    "该游戏账号下的游戏虚拟道具及其他增值服务（以下统称“游戏收益”）也将会被清除。您理解并同意，我方无法协助您重新恢复前述游戏收益。",
    "注销成功后，如届时该游戏账号下还存在游戏收益的（包括但不限于在本游戏使用期间已产生但尚未失效或未使用的游戏虚拟道具及其他游戏增值服务，及未来可能产生的游戏收益），视为您自愿放弃，将无法继续使用。",
    "前述游戏收益包括但不限于：游戏会员权益、等级；与游戏角色成长升级相关的所有数据（包括但不限于经验值、荣誉值、声望值、称号等）；尚未使用的游戏虚拟货币、虚拟道具及其他虚拟物品（如卡券、金币、钻石、道具及其他等）；已经购买但未到期或未使用完的其他增值服务；已产生但未消耗完毕的其他游戏收益或未来预期的游戏收益等。",
    "在您的账号注销期间，如果您的账号被他人投诉、被国家机关调查或者正处于诉讼、仲裁程序中，我方有权自行终止您的账号注销而无需另行得到您的同意。",
    "请注意，注销您的游戏账号并不代表账号注销前的账号行为和相关责任得到豁免或减轻。",
  ],
};

// 冷静期天数
export const COOLING_DAYS = 15;

// 在 "YYYY-MM-DD HH:mm:ss" 基础上加 days 天（兼容 iOS：把 - 换成 /）
export const addDays = (timeStr, days) => {
  if (!timeStr) return "";
  const d = new Date(String(timeStr).replace(/-/g, "/"));
  if (isNaN(d.getTime())) return "";
  d.setDate(d.getDate() + days);
  const pad = (n) => `${n}`.padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};
